<section>
  <router-outlet></router-outlet>
</section>